import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { AuthContextResponse } from './type';

export interface AuthContextRequest {
  companyId: string;
  clubId?: string;
  options?: Record<string, boolean>;
}

const getAuthContext = async ({ companyId, clubId }: AuthContextRequest) => {
  const clubIdParam = clubId ? `?clubId=${clubId}` : '';
  const url = `${import.meta.env.VITE_AUTH_SERVICE_HOST}/v1/nightgraph/companies/${companyId}/auth/context${clubIdParam}`;
  return request({ url, method: RequestMethod.GET });
};

export const useGetAuthContext = ({ companyId, clubId, options }: AuthContextRequest) => {
  return useGenericQuery<AuthContextResponse, RequestError>(
    ['get-auth-context'],
    async () => getAuthContext({ companyId, clubId }),
    {
      ...options,
    }
  );
};
